import { createSelector } from 'reselect';
import { replenCarouselPurchaseHistorySelector } from 'selectors/testTarget/offers/replenCarouselPurchaseHistory/replenCarouselPurchaseHistorySelector';

/**
 * Whether the `replenCarouselPurchaseHistory` A/B test challenger is active.
 * @param {Object} state - Redux state
 * @returns {boolean} `true` when the offer's `show` flag is set, otherwise `false`.
 */
const showSelector = createSelector(replenCarouselPurchaseHistorySelector, replenCarouselPurchaseHistory => !!replenCarouselPurchaseHistory.show);

export { showSelector };
